import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc5835d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { xs: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_typography_title, { level: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode(" 星汉未来资料中心 ")
                ]),
                _: 1 /* STABLE */
              }),
              _createCommentVNode("<a-input v-model:value=\"form.data.search\" placeholder=\"搜索\""),
              _createCommentVNode("         class=\"box_input\" size=\"large\""),
              _createCommentVNode("         :maxlength=\"20\" :show-count=\"form.data.search.length>0\""),
              _createCommentVNode("         @pressEnter=\"pressEnter\" allow-clear>"),
              _createCommentVNode("    <template #prefix>"),
              _createCommentVNode("        <SearchOutlined />"),
              _createCommentVNode("    </template>"),
              _createCommentVNode("</a-input>")
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}